module.exports = __webpack_public_path__ + "img/cover.15cbab57.png";